import { formatNumber } from '@/lib/format';

/** A single stacked strip: part-to-whole for two or three classes, direct-labelled. */
export function Strip({ parts }: { parts: Array<{ label: string; value: number; tone: 'accent' | 'soft' | 'gray' | 'danger' }> }) {
  const total = parts.reduce((s, p) => s + p.value, 0);
  const colour = { accent: 'var(--chart-1)', soft: 'var(--chart-1-soft)', gray: 'var(--chart-gray)', danger: 'var(--chart-neg)' };
  return (
    <div>
      <div className="flex h-2.5 w-full gap-0.5 overflow-hidden rounded-full bg-surface-3">
        {total > 0 && parts.filter((p) => p.value > 0).map((p) => (
          <div key={p.label} title={`${p.label}: ${formatNumber(p.value)}`} style={{ width: `${(p.value / total) * 100}%`, background: colour[p.tone] }} className="h-full first:rounded-l-full last:rounded-r-full" />
        ))}
      </div>
      <ul className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs">
        {parts.map((p) => (
          <li key={p.label} className="flex items-center gap-1.5 text-muted">
            <span className="h-2 w-2 rounded-full" style={{ background: colour[p.tone] }} />
            {p.label} <span className="font-semibold text-ink tabular-nums">{formatNumber(p.value)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
